export const TRAJECTORY_EDITABLE_FIELDS = ['md', 'inc', 'azi', 'mtf', 'gtf', 'comment', 'typeTrajStation'] as const;

export type TTrajectoryEditableField = (typeof TRAJECTORY_EDITABLE_FIELDS)[number];

const EDITABLE_FIELD_SET = new Set<string>(TRAJECTORY_EDITABLE_FIELDS);

export function isTrajectoryEditableField(field: string): field is TTrajectoryEditableField {
  return EDITABLE_FIELD_SET.has(field);
}
